const form = document.querySelector("form.crawfish-form-2026");

if (form) {
  const companyHiddenInput = form.querySelector("input[id='1123955071']");
  const companySelect = form.querySelector("#company-select");
  const companyOtherWrapper = form.querySelector("#company-other-wrapper");
  const companyOtherInput = form.querySelector("#company-other");

  const updateCompanyValue = function() {
    if (!companyHiddenInput || !companySelect) {
      return;
    }

    const isOther = companySelect.value === "Other";

    console.log(isOther);

    if (companyOtherWrapper && companyOtherInput) {
      companyOtherWrapper.classList.toggle("hidden-field", !isOther);
      companyOtherInput.required = isOther;

      if (!isOther) {
        companyOtherInput.value = "";
      }
    }

    if (isOther && companyOtherInput) {
      companyHiddenInput.value = companyOtherInput.value.trim();
      return;
    }

    companyHiddenInput.value = companySelect.value;
  };

  if (companySelect) {
    companySelect.addEventListener("change", updateCompanyValue);
  }

  if (companyOtherInput) {
    companyOtherInput.addEventListener("input", updateCompanyValue);
  }

  updateCompanyValue();

  form.addEventListener("submit", function(event) {
    event.preventDefault();
    updateCompanyValue();

    const formData = new FormData(form);
    const thankYouPage = form.querySelector("#thank-you-page").getAttribute("href");
    const button = form.querySelector("button[type='submit']");
    button.disabled = true;

    fetch(form.action, {
      method: "POST",
      body: formData,
    })
    .then(response => {
      //window.location.href = "/thank-you";
    })
    .catch((error) => {
      //window.location.href = "/thank-you";
    })
    .finally(() => {
      form.setAttribute("action", thankYouPage);
      form.submit();
    });
  });
}